import { EmptyBoxContainer } from "./EmptyBox.style";

const EmptyBox = () => {
  return (
    <EmptyBoxContainer>
      <h2>
        당신만의 URL을 등록하고 관리해보세요!
      </h2>
    </EmptyBoxContainer>
  );
};

export default EmptyBox;